import { Injectable, inject } from '@angular/core';
import { enumAplicacionIVA, enumTipoOperacion, eRegimenFiscalDocs, eTipoArticulo, eTipoLineaMovimientos, eTipoModalidadFacturas, eTipoMovimiento } from 'src/GlobalConf';
import { VariablesGlobalesService } from './variables-globales.service';
import { enumTipoDocumento } from '../../GlobalConf';
import { ArticuloDocumentoApp, BaseDocumentoDTO, DocumentoDTO, MovimientoDTO, RetencionFiscalDTO } from '../Models/ApiV2/DocumentoDTO';
import { TipoIvaGestionDTO } from '../Models/ApiV2/TipoIvaGestionDTO';
import { TipoIrpfGestionDTO } from '../Models/ApiV2/TipoIrpfGestionDTO';

@Injectable({
  providedIn: 'root'
})
export class CalculosDocumentosService {
  variablesGlobales = inject(VariablesGlobalesService);

  paramDecimalesMoneda: number
  movPrueba: MovimientoDTO;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);
  constructor() {
    console.log('this.variablesGlobales.parametros: ', this.variablesGlobales.parametros);
    
    this.paramDecimalesMoneda = parseInt(this.variablesGlobales.parametros.find(parametro => parametro.Codigo == 'DecimalesMoneda').Valor)
  }

  ///* 

  async calcularTotalesDocumento(documento: DocumentoDTO, grupoDocumento) {
    console.log('CalcularTotalesDocumento');
    console.log('Documento: ', JSON.stringify(documento))
    await this.calcularLineas(false, documento);
    await this.calcularTotalBruto(documento);
    await this.calcularDescuentos(documento);
    await this.calcularIvas(documento, grupoDocumento);
    //AplicarBasesImportacion( ); // Solo si estamos en modo importación se modifican las bases de los movimientos con las bases de importación
    await this.calcularRetenciones(documento);
    await this.calcularTotales(documento);
    return documento;
  }

  calcularImportesLinea(CalcularImporte: boolean, forzarRecalculo: boolean, documento: DocumentoDTO, movimiento: MovimientoDTO) {
    console.log('Entro en calcularImportesLinea');

    forzarRecalculo = false;
    let precio: number = 0;
    let importe: number = 0;
    let porcentajeDescuento1: number = 0;
    let porcentajeDescuento2: number = 0;
    let porcentajeDescuento3: number = 0;
    let descuentoCantidad: number = 0;
    let importeDescuento1: number = 0;
    let importeDescuento2: number = 0;
    let importeDescuento3: number = 0;
    let importeDescuentoCantidad: number = 0;
    let importeDescuentoLinea: number = 0;
    let porcentajeIva: number = 0;
    let porcentajeRecargo: number = 0;
    let sumaDescuentos: number = 0;
    let diferenciaTemporal: number = 0;
    let unidadCalculo: number = 0;

    unidadCalculo = movimiento.unidad1

    if (unidadCalculo == 0) {
      unidadCalculo = 1
    }

    //Si el movimiento no tiene tipoIva lo buscamos --> primero por el TipoIva del Artículo y si no encuentra le asigna el IVA defecto
    // //ESTA PARTE SE SUPONE QUE NO TENEMOS QUE HACERLA PORQUE LA API YA NOS VA A DEVOLVER EL TIPO DE IVA
    // // if (!movimiento.id_TipoIva) {
    // //   if(movimiento.id_Articulo){
    // //     let codIva: number = null;
    // //     let oGArt = new GestionArticulos();
    // //     oGArt.colBases = colBases;
    // //     oGArt.inicializar();
    // //     codIva = oGArt.obtenerTipoIvaArticulo(movimiento.id_Articulo.value);
    // //     oGArt.dispose()
    // //     if(codIva != null && gestionIVA.buscarIVA(codIva.value)){
    // //       movimiento.id_TipoIva = gestionIVA.registro.id;
    // //     }
    // //   }
    // //   if(!movimiento.id_TipoIva){
    // //     _lectorParametros.limpiarGrupoParametros( );
    // //     _lectorParametros.anadirGrupoParametros( Parametros.CNT_Grupo_Articulos );
    // //     _lectorParametros.CargarDatosFicherosDesdeGrupos( );
    // //     object ivaDefecto = _lectorParametros.ValorParametro( Parametros.CNT_Grupo_Articulos, Parametros.CNT_Param_IVADefectoArticulos, 0 );
    // //     let iva:number = 0;

    // //     if(ivaDefecto != null && byte.TryParse( ivaDefecto.ToString( ), out iva ) && gestionIVA.buscarIVA( iva ) ){
    // //       movimiento.id_TipoIva = gestionIVA.registro.id;
    // //     }
    // //   }
    // // }
    // // if(gestionIVA.buscarIVAporID(movimiento.id_TipoIva) == false){
    // //   gestionIVA.CargarRegistro_PorId(movimiento.id_TipoIva)
    // // }


    porcentajeIva = movimiento.tipoIva.porcentajeIva;
    porcentajeRecargo = movimiento.tipoIva.porcentajeRecargo;
    porcentajeDescuento1 = movimiento.descuento1 ?? 0;
    porcentajeDescuento2 = movimiento.descuento2 ?? 0;
    porcentajeDescuento3 = movimiento.descuento3 ?? 0;
    descuentoCantidad = movimiento.descuentoCantidad;
    importeDescuentoLinea = movimiento.descuentoLinea;

    if (documento.ivaIncluido != 0) { //REVISAR ESTA LINEA CON LA QUE VIENE EN EL DOCUMENTO DE ALBERTO
      precio = movimiento.precioConIva
    } else {
      precio = movimiento.precio
    }

    switch (documento.iva) {
      case enumAplicacionIVA.IVA:
        porcentajeRecargo = 0;
        break;

      case enumAplicacionIVA.IVARECARGO:
        if (movimiento.articulo?.tipo == eTipoArticulo.SV.toString()) { porcentajeRecargo = 0; }
        break;

      case enumAplicacionIVA.EXENTO:
        if (movimiento.porcentajeNoDeducible == 0) {
          porcentajeIva = 0;
        }
        porcentajeRecargo = 0;
        break;
    }

    if (CalcularImporte) {
      importe = unidadCalculo * precio;
    } else {
      importe = movimiento.importe;
    }

    if (porcentajeDescuento1 != 0) {
      importeDescuento1 = importe * porcentajeDescuento1 / 100;
    }

    if (porcentajeDescuento2 != 0) {
      importeDescuento2 = (importe - importeDescuento1) * porcentajeDescuento2 / 100;
    }

    if (porcentajeDescuento3 != 0) {
      importeDescuento3 = (importe - importeDescuento1 + importeDescuento2) * porcentajeDescuento3 / 100;
    }

    importeDescuentoCantidad = descuentoCantidad * unidadCalculo;
    sumaDescuentos = importeDescuento1 + importeDescuento2 + importeDescuento3 + importeDescuentoCantidad + importeDescuentoLinea
    importe = importe - sumaDescuentos

    importe = this.RoundAwayFromZero(importe, this.paramDecimalesMoneda);
    sumaDescuentos = this.RoundAwayFromZero(sumaDescuentos, this.paramDecimalesMoneda);
    importeDescuento1 = this.RoundAwayFromZero(importeDescuento1, this.paramDecimalesMoneda);
    importeDescuento2 = this.RoundAwayFromZero(importeDescuento2, this.paramDecimalesMoneda);
    importeDescuento3 = this.RoundAwayFromZero(importeDescuento3, this.paramDecimalesMoneda);
    importeDescuentoCantidad = this.RoundAwayFromZero(importeDescuentoCantidad, this.paramDecimalesMoneda);
    diferenciaTemporal = sumaDescuentos - importeDescuento1 - importeDescuento2 - importeDescuento3 - importeDescuentoCantidad - importeDescuentoLinea;

    if (diferenciaTemporal != 0) {
      if (importeDescuento1 != 0) {
        importeDescuento1 = importeDescuento1 + diferenciaTemporal;
      } else {
        if (importeDescuento2 != 0) {
          importeDescuento2 = importeDescuento2 + diferenciaTemporal;
        } else {
          if (importeDescuento3 != 0) {
            importeDescuento3 = importeDescuento3 + diferenciaTemporal;
          } else {
            if (importeDescuentoCantidad != 0) {
              importeDescuentoCantidad = importeDescuentoCantidad + diferenciaTemporal;
            } else {
              if (importeDescuentoLinea != 0) {
                importeDescuentoLinea = importeDescuentoLinea + diferenciaTemporal;
              }
            }
          }
        }
      }
    }

    //if (movimiento.estadoEntidad != eEstadoEntidad.SIN_ESTADO || forzarRecalculo) {
    if (true) {//Esta linea en el fichero de alberto comprueba que NO ESTE en modo importación. Nostros NUNCA vamos a estar en modo importación, por lo que simpre será true 
      if (movimiento.tipoLinea == eTipoLineaMovimientos.ANTICIPO /*&& movimiento.anticipoFacturado*/) {
        movimiento.importeConIva = movimiento.precioConIva;
        movimiento.precio = movimiento.importe = this.RoundAwayFromZero(movimiento.precioConIva / ((porcentajeIva + porcentajeRecargo + 100) / 100), this.paramDecimalesMoneda);
      } else {
        if (documento.ivaIncluido != 0) {
          movimiento.importeConIva = importe;
          movimiento.precioConIva = precio;
          movimiento.importe = this.RoundAwayFromZero(importe / ((porcentajeIva + porcentajeRecargo + 100) / 100), this.paramDecimalesMoneda)
          movimiento.precio = this.RoundAwayFromZero(precio / ((porcentajeIva + porcentajeRecargo + 100) / 100), this.paramDecimalesMoneda)
        } else {
          movimiento.importe = importe;
          movimiento.precio = precio;
          movimiento.importeConIva = this.RoundAwayFromZero(importe + importe * porcentajeIva / 100 + importe * porcentajeRecargo / 100, this.paramDecimalesMoneda);
          movimiento.precioConIva = this.RoundAwayFromZero(precio + precio * porcentajeIva / 100 + precio * porcentajeRecargo / 100, this.paramDecimalesMoneda);
        }
      }

    } else {//Aqui nunca entra porque entra cuando es una importación y como nunca va a ser pues no estra
      let importeCalculado: number = 0;
      let importeConIvaCalculado: number = 0;
      let precioCalculado: number = 0;
      let precioConIvaCalculado: number = 0;

      if (documento.ivaIncluido) {//REVISAR ESTA LINEA CON LA QUE VIENE EN EL DOCUMENTO DE ALBERTO
        importeConIvaCalculado = importe;
        precioConIvaCalculado = precio;
        importeCalculado = this.RoundAwayFromZero(importe / ((porcentajeIva + porcentajeRecargo + 100) / 100), this.paramDecimalesMoneda);
        precioCalculado = this.RoundAwayFromZero(precio / ((porcentajeIva + porcentajeRecargo + 100) / 100), this.paramDecimalesMoneda);
      } else {
        importeCalculado = importe;
        precioCalculado = precio;
        importeConIvaCalculado = this.RoundAwayFromZero(importe + importe * porcentajeIva / 100 + importe * porcentajeRecargo / 100, this.paramDecimalesMoneda);
        precioConIvaCalculado = this.RoundAwayFromZero(precio + precio * porcentajeIva / 100 + precio * porcentajeRecargo / 100, this.paramDecimalesMoneda);
      }

      if (movimiento.importeConIva == 0) {
        movimiento.importeConIva = importeCalculado;
      } else if (movimiento.importeConIva != importeCalculado) {
        console.warn('documento ', documento.referenciaExterna + ' Movimiento ', movimiento.linea, '- El importe con iva ', movimiento.importeConIva, ' difiere del importe con iva calculado ', importeConIvaCalculado);

      }

      if (movimiento.importe == 0) {
        movimiento.importe = importeCalculado;
      } else if (movimiento.importe != importeCalculado) {
        console.warn('documento ', documento.referenciaExterna + ' Movimiento ', movimiento.linea, '- El importe ', movimiento.importe, ' difiere del importe calculado ', importeCalculado);
      }

      if (movimiento.precio == 0) {
        movimiento.precio = precioCalculado
      } else if (movimiento.precio != precioCalculado) {
        console.warn('documento ', documento.referenciaExterna + ' Movimiento ', movimiento.linea, '- El precio ', movimiento.precio, ' difiere del precio calculado ', precioCalculado);
      }

      if (movimiento.precioConIva == 0) {
        movimiento.precioConIva = precioConIvaCalculado;
      } else if (movimiento.precioConIva != precioConIvaCalculado) {
        console.warn('documento ', documento.referenciaExterna + ' Movimiento ', movimiento.linea, '- El precio con iva ', movimiento.precioConIva, ' difiere del precio con iva calculado ', precioConIvaCalculado);
      }
    }

    //}

    movimiento.precio = movimiento.precio;
    movimiento.importe = movimiento.importe;

    movimiento.tipoIva.porcentajeIva = porcentajeIva;
    movimiento.tipoIva.porcentajeRecargo = porcentajeRecargo;
    //Esta linea se supone que nos lo tiene que devolver la api en el articulo y se asignaría al movimiento al añadir al articulo
    //movimiento.codigoTipoIva = gestionIVA.Registro.Codigo;

    movimiento.importeDescuento1 = importeDescuento1;
    movimiento.importeDescuento2 = importeDescuento1;
    movimiento.importeDescuento3 = importeDescuento3;
    movimiento.importeDescuentoCantidad = importeDescuentoCantidad;
    movimiento.descuentoLinea = importeDescuentoLinea;

    if (movimiento.tipoTarifaPrecios == null) {
      movimiento.tipoTarifaPrecios = documento.tipoTarifaPrecios;
    }

    if (movimiento.tipoTarifaDescuentos == null) {
      movimiento.tipoTarifaDescuentos = documento.tipoTarifaDescuentos;
    }

    console.log('Movimiento final: ', movimiento);
  }

  calcularDescuentos(documento: DocumentoDTO) {
    console.log('Entro en calcularDescuentos.');

    let importeBruto: number = 0;
    let importeDescuentoLinea: number = 0;
    let acumuladoAjuste: number = 0;
    let importeMovimientoUtilizar: number = 0;
    documento.totalDescuento = 0;
    documento.importeDescuento1 = 0;
    documento.importeDescuento2 = 0;
    documento.importeDescuento3 = 0;
    documento.importeDescuento4 = 0;

    if (documento.descuento1 + documento.descuento2 + documento.descuento3 + documento.descuento4 < 0) {
      return
    }

    importeBruto = documento.totalBruto

    if (documento.descuento1 != 0) {
      documento.importeDescuento1 = this.RoundAwayFromZero(importeBruto * documento.descuento1 / 100, this.paramDecimalesMoneda)
      importeBruto = importeBruto - documento.importeDescuento1
    }
    if (documento.descuento2 != 0) {
      documento.importeDescuento2 = this.RoundAwayFromZero(importeBruto * documento.descuento2 / 100, this.paramDecimalesMoneda)
      importeBruto = importeBruto - documento.importeDescuento2
    }
    if (documento.descuento3 != 0) {
      documento.importeDescuento3 = this.RoundAwayFromZero(importeBruto * documento.descuento3 / 100, this.paramDecimalesMoneda)
      importeBruto = importeBruto - documento.importeDescuento3
    }
    if (documento.descuento4 != 0) {
      documento.importeDescuento4 = this.RoundAwayFromZero(importeBruto * documento.descuento4 / 100, this.paramDecimalesMoneda)
      importeBruto = importeBruto - documento.importeDescuento4
    }

    documento.totalDescuento = documento.importeDescuento1 + documento.importeDescuento2 + documento.importeDescuento3 + documento.importeDescuento4;
    acumuladoAjuste = 0;

    if (documento.movimientos.length > 0) {
      for (let i = 0; i < documento.movimientos.length; i++) {
        if (documento.movimientos[i].tipoLinea != eTipoLineaMovimientos.OBSERVACIONES && documento.movimientos[i].tipoLinea != eTipoLineaMovimientos.DESGLOSEPAQUETE) {
          importeMovimientoUtilizar = 0;
          if (documento.ivaIncluido == 1) {
            importeMovimientoUtilizar = documento.movimientos[i].importeConIva;
          } else {
            importeMovimientoUtilizar = documento.movimientos[i].importe;
          }
          importeDescuentoLinea = 0;
          if (documento.totalDescuento != 0) {
            importeDescuentoLinea = this.RoundAwayFromZero(importeMovimientoUtilizar * documento.totalDescuento / documento.totalBruto, this.paramDecimalesMoneda)
            acumuladoAjuste += importeDescuentoLinea
          }
          documento.movimientos[i].importeBruto = importeMovimientoUtilizar - importeDescuentoLinea
        }
      }
      console.log(documento.movimientos.length);

      documento.movimientos[documento.movimientos.length - 1].importeBruto += documento.totalDocumento - acumuladoAjuste
    }
    console.log('Documento final calcularDescuentos: ', documento);

  }

  async calcularLineas(forzarRecalculo: boolean, documento: DocumentoDTO) {
    console.log('Entro en calcular lineas. Documento: ', documento.movimientos.length);
    //console.log('Entro en calcular lineas. Documento: ', JSON.stringify(documento));

    //forzarRecalculo = false
    for (let i = 0; i < documento.movimientos.length; i++) {
      console.log('Recorro moviminetos. ',documento.movimientos[i]);

      if (/*(movimiento.id_Documento != null || movimiento.id_Albaran != null) && */
        documento.movimientos[i].tipoLinea != eTipoLineaMovimientos.OBSERVACIONES
        && (documento.tipoDocumento != enumTipoDocumento.FAB || documento.tipoDocumento == enumTipoDocumento.FAB && documento.movimientos[i].tipoMovimiento == eTipoMovimiento.EntradasFabricacion)
        && (documento.tipoDocumento != enumTipoDocumento.DES || documento.tipoDocumento == enumTipoDocumento.DES && documento.movimientos[i].tipoMovimiento == eTipoMovimiento.SalidasFabricacion)) {
        await this.calcularImportesLinea(true, forzarRecalculo, documento, documento.movimientos[i])
      }
    }
    console.log('Lineas calculadas: ', documento);
    //console.log('Lineas calculadas: ', JSON.stringify(documento));


  }

  calcularTotalBruto(documento: DocumentoDTO) {
    console.log('Entro en calcularTotalBruto.');
    documento.totalBruto = 0
    for (let i = 0; i < documento.movimientos.length; i++) {
      if (documento.ivaIncluido == 1) {
        documento.totalBruto += this.RoundAwayFromZero(documento.movimientos[i].importeConIva, this.paramDecimalesMoneda);
      } else {
        documento.totalBruto += this.RoundAwayFromZero(documento.movimientos[i].importe, this.paramDecimalesMoneda)
      }
    }
    console.log('Documento final calcularTotalBruto: ', documento);
  }


  async calcularIvas(documento: DocumentoDTO, grupoDocumento: string) {
    let baseTemporal: number = 0;
    let importeDescuentoGestion: number = 0;
    let acumuladoAjuste: number = 0;
    let importeDescuentoGestionCalculado: number = 0;
    let acumuladoAjusteCalculado: number = 0;
    let sumaAnticiposPre: number = 0;
    let sumaImportesCompra: number = 0;
    let sumaImportesConIva: number = 0;
    let tipoArticulo: string = "";
    let tipoOperacion: number = 0;
    let anticiposFacturados: boolean = false;

    try {
      documento.basesIVA = [];
      anticiposFacturados = documento.movimientos.filter((movimiento: MovimientoDTO) => movimiento.tipoLinea == eTipoLineaMovimientos.ANTICIPO /*&& movimiento.AnticipoFacturado*/).length > 0;

      // Recorremos las lineas para calcular las bases de cada una de ellas
      for (let i = 0; i < documento.movimientos.length; i++) {
        let baseDocumento: BaseDocumentoDTO
        if (documento.movimientos[i].tipoLinea == eTipoLineaMovimientos.ANTICIPO /*&& linea.AnticipoFacturado == false*/) {
          sumaAnticiposPre += documento.movimientos[i].importeConIva;
        }

        if (documento.movimientos[i].tipoLinea != eTipoLineaMovimientos.OBSERVACIONES && documento.movimientos[i].tipoLinea != eTipoLineaMovimientos.DESGLOSEPAQUETE
          && (documento.movimientos[i].tipoLinea != eTipoLineaMovimientos.RETENCION || documento.movimientos[i].tipoLinea == eTipoLineaMovimientos.RETENCION
            /*&& documento.DocumentoAuxiliarJSON?.DatosObra.RetencionAfectaIVA == true*/)
          && (documento.movimientos[i].tipoLinea != eTipoLineaMovimientos.ANTICIPO
            || documento.movimientos[i].tipoLinea == eTipoLineaMovimientos.ANTICIPO /*&& linea.AnticipoFacturado*/)
        ) {
          tipoOperacion = await this.obtenerTipoOperacionesBasePorTipoArticulo(documento.movimientos[i].articulo.tipo);

          baseDocumento = await this.buscarBasesLista_PorID_IVA(documento, documento.movimientos[i].tipoIva.id, documento.movimientos[i].regimenFiscal, documento.movimientos[i].inversion, documento.movimientos[i].prorrata, tipoOperacion, documento.movimientos[i].porcentajeNoDeducible)
          console.log({ baseDocumento });
          console.log('linea: ', documento.movimientos[i]);
          let nuevaBaseDocumento: boolean = false
          if (!baseDocumento) {
            nuevaBaseDocumento = true;
            baseDocumento = new BaseDocumentoDTO();
            baseDocumento.actividad = documento.movimientos[i].actividad;
            baseDocumento.inversion = documento.movimientos[i].inversion;
            baseDocumento.prorrata = documento.movimientos[i].prorrata;
            baseDocumento.tipoIva = new TipoIvaGestionDTO();
            baseDocumento.tipoIva.id = documento.movimientos[i].tipoIva.id;
            baseDocumento.regimenFiscal = documento.movimientos[i].regimenFiscal;
            baseDocumento.tipoOperacion = tipoOperacion;
            baseDocumento.porcentajeNoDeducible = documento.movimientos[i].porcentajeNoDeducible;
            baseDocumento.total = 0
            baseDocumento.baseImponible = 0
            baseDocumento.baseImponibleCalculada = 0
          }
          baseDocumento.tipoIva.porcentajeIva = documento.movimientos[i].tipoIva.porcentajeIva;
          baseDocumento.tipoIva.porcentajeRecargo = documento.movimientos[i].tipoIva.porcentajeRecargo;

          // if (linea.tipoIva.porcentajeIva > 0 || baseDocumento.porcentajeNoDeducible > 0) {
          //   switch (grupoDocumento) {
          //     case "CL":
          //       baseDocumento.CodigoCuentaIVA = linea.CuentaIvaEmitido;
          //       baseDocumento.CodigoCuentaRecargo = linea.CuentaRecargoEmitido;
          //       break;

          //     case "PR":
          //       baseDocumento.CodigoCuentaIVA = linea.CuentaIvaSoportado;
          //       baseDocumento.CodigoCuentaRecargo = linea.CuentaRecargoSoportado;
          //       break;
          //   }
          //   if (baseDocumento.CodigoCuentaIVA != null && baseDocumento.CodigoCuentaIVA != "") {
          //     ProcesarCuentasBaseActiva("CuentaIVA");
          //   }
          //   if (baseDocumento.CodigoCuentaRecargo != null && baseDocumento.CodigoCuentaRecargo != "") {
          //     ProcesarCuentasBaseActiva("CuentaRECARGO");
          //   }
          // }

          if (documento.ivaIncluido == 1 || anticiposFacturados) {
            if (documento.movimientos[i].regimenFiscal == eRegimenFiscalDocs.Regimen_Especial_Bienes_Usados
              && documento.movimientos[i].tipoMovimiento == eTipoMovimiento.SalidasClientes) {
              sumaImportesCompra += documento.movimientos[i].importeCompra ?? 0;
              sumaImportesConIva += documento.movimientos[i].importeConIva;
              baseDocumento.total += this.RoundAwayFromZero(documento.movimientos[i].importeConIva - documento.movimientos[i].importeCompra, this.paramDecimalesMoneda);
              if (baseDocumento.total < 0) {
                baseDocumento.total = 0;
              }
            } else {
              baseDocumento.total += documento.movimientos[i].importeConIva;
            }
          } else {
            baseDocumento.baseImponible += documento.movimientos[i].importe;
            baseDocumento.baseImponibleCalculada += documento.movimientos[i].importe;
          }

          if (nuevaBaseDocumento) {
            documento.basesIVA.push(baseDocumento);
          }
        }
        
      }

      //ESTO SE UTILIZA EN IMPORTACIONES
      // //En una facturación de albaranes de compra podemos indicar la base imponible que utilizar. Ésta es la que asignamos en BasesDocumentos
      // foreach(BaseDocumento basedoc in _listaBasesModificadas)
      // {
      //                BasesDocumentos BaseImponible = listaBases.FirstOrDefault(b => b.Id_TipoIva == basedoc.Id_TipoIva && b.TipoOperacion == basedoc.TipoOperacion);
      //   if (BaseImponible != null && basedoc.BaseImponibleModificada != null) { BaseImponible.BaseImponible = basedoc.BaseImponibleModificada; }
      //   if (BaseImponible != null && basedoc.ImporteIVA != null) {
      //     BaseImponible.ImporteIVA = basedoc.ImporteIVA;
      //     Documento.CalculoIvaAutomatico = false;
      //   }
      // }

      // Recorremos las bases para prorratear los descuentos al pie
      if (documento.totalDescuento != 0 /*&& documento.CalculoIvaAutomatico*/) {
        for (let i = 0; i < documento.basesIVA.length; i++) {
          importeDescuentoGestion = 0;
          importeDescuentoGestionCalculado = 0;
          if (documento.ivaIncluido == 1 || anticiposFacturados) {
            importeDescuentoGestion = this.RoundAwayFromZero(documento.basesIVA[i].total * documento.totalDescuento / documento.totalBruto, this.paramDecimalesMoneda);
            documento.basesIVA[i].total -= importeDescuentoGestion
          } else {
            importeDescuentoGestion = this.RoundAwayFromZero((documento.basesIVA[i].baseImponible ?? 0) * documento.totalDescuento / documento.totalBruto, this.paramDecimalesMoneda);
            documento.basesIVA[i].baseImponible -= importeDescuentoGestion;

            importeDescuentoGestionCalculado = this.RoundAwayFromZero((documento.basesIVA[i].baseImponibleCalculada ?? 0) * documento.totalDescuento / documento.totalBruto, this.paramDecimalesMoneda);
            documento.basesIVA[i].baseImponibleCalculada -= importeDescuentoGestionCalculado;
          }
          acumuladoAjuste += importeDescuentoGestion;
          acumuladoAjusteCalculado += importeDescuentoGestionCalculado;
        }

        importeDescuentoGestion = documento.totalDescuento - acumuladoAjuste;
        importeDescuentoGestionCalculado = documento.totalDescuento - acumuladoAjusteCalculado;

        if (importeDescuentoGestion != 0) {
          for (let i = 0; i < documento.basesIVA.length; i++) {
            if (documento.ivaIncluido == 1 || anticiposFacturados) {
              documento.basesIVA[i].total += importeDescuentoGestion;
            } else {
              documento.basesIVA[i].baseImponible += importeDescuentoGestion;
            }
            //return;
          }
        }

        if (importeDescuentoGestionCalculado != 0) {
          for (let i = 0; i < documento.basesIVA.length; i++) {
            documento.basesIVA[i].baseImponibleCalculada += importeDescuentoGestionCalculado;
            //return;
          }
        }
      }

      for (let i = 0; i < documento.basesIVA.length; i++) {
        if (documento.ivaIncluido == 0 && !anticiposFacturados) {
          switch (documento.iva) {
            case 0:
              documento.basesIVA[i].importeIVA = this.RoundAwayFromZero((documento.basesIVA[i].baseImponible ?? 0) * (documento.basesIVA[i].tipoIva.porcentajeIva ?? 0) / 100, this.paramDecimalesMoneda);
              documento.basesIVA[i].importeRecargo = 0;
              break;

            case 1:
              documento.basesIVA[i].importeIVA = this.RoundAwayFromZero((documento.basesIVA[i].baseImponible ?? 0) * (documento.basesIVA[i].tipoIva.porcentajeIva ?? 0) / 100, this.paramDecimalesMoneda);
              documento.basesIVA[i].importeRecargo = this.RoundAwayFromZero((documento.basesIVA[i].baseImponible ?? 0) * (documento.basesIVA[i].tipoIva.porcentajeRecargo ?? 0) / 100, this.paramDecimalesMoneda);
              break;

            case 2:
              if (documento.basesIVA[i].porcentajeNoDeducible > 0) {
                documento.basesIVA[i].importeIVA = this.RoundAwayFromZero((documento.basesIVA[i].baseImponible ?? 0) * (documento.basesIVA[i].tipoIva.porcentajeIva ?? 0) / 100, this.paramDecimalesMoneda);
              }
              else {
                documento.basesIVA[i].importeIVA = 0;
              }

              documento.basesIVA[i].importeRecargo = 0;
              break;
          }
        } else {
          // 1- Se obtiene la base imponible temporal, quitando al Total el porcentaje de IVA.
          // 2- A continuación se obtiene el IVA, aplicando a la base imponible temporal el porcentaje de IVA.
          // 3- Finalmente se obtiene la base imponible definitiva restando al importe total el IVA calculado (sobre la base imponible temporal).
          switch (documento.iva) {
            case 0:
              baseTemporal = this.RoundAwayFromZero(documento.basesIVA[i].total / (((documento.basesIVA[i].tipoIva.porcentajeIva ?? 0) + 100) / 100), this.paramDecimalesMoneda);
              documento.basesIVA[i].importeIVA = this.RoundAwayFromZero(baseTemporal * (documento.basesIVA[i].tipoIva.porcentajeIva ?? 0) / 100, this.paramDecimalesMoneda);
              documento.basesIVA[i].importeRecargo = 0;
              break;

            case 1:
              baseTemporal = this.RoundAwayFromZero(documento.basesIVA[i].total / (((documento.basesIVA[i].tipoIva.porcentajeIva ?? 0) + (documento.basesIVA[i].tipoIva.porcentajeRecargo ?? 0) + 100) / 100), this.paramDecimalesMoneda);
              documento.basesIVA[i].importeIVA = this.RoundAwayFromZero(baseTemporal * (documento.basesIVA[i].tipoIva.porcentajeIva ?? 0) / 100, this.paramDecimalesMoneda);
              documento.basesIVA[i].importeRecargo = this.RoundAwayFromZero(baseTemporal * (documento.basesIVA[i].tipoIva.porcentajeRecargo ?? 0) / 100, this.paramDecimalesMoneda);
              break;

            case 2:

              if (documento.basesIVA[i].porcentajeNoDeducible > 0) {
                baseTemporal = this.RoundAwayFromZero(documento.basesIVA[i].total / (((documento.basesIVA[i].tipoIva.porcentajeIva ?? 0) + 100) / 100), this.paramDecimalesMoneda);
                documento.basesIVA[i].importeIVA = this.RoundAwayFromZero(baseTemporal * (documento.basesIVA[i].tipoIva.porcentajeIva ?? 0) / 100, this.paramDecimalesMoneda);
                documento.basesIVA[i].importeRecargo = 0;
              }
              else {
                baseTemporal = documento.basesIVA[i].total;
                documento.basesIVA[i].baseImponibleCalculada = documento.basesIVA[i].total;
                documento.basesIVA[i].importeIVA = 0;
                documento.basesIVA[i].importeRecargo = 0;
              }

              break;
          }

          documento.basesIVA[i].baseImponible = documento.basesIVA[i].total - documento.basesIVA[i].importeIVA - documento.basesIVA[i].importeRecargo;
        }

        //}
        // Esto se pone por si tenemos movimientos con distintos regímenes fiscales y alguno es ISP
        if (documento.basesIVA[i].regimenFiscal == eRegimenFiscalDocs.Inversion_Sujeto_Pasivo && documento.iva != enumAplicacionIVA.EXENTO) {
          documento.basesIVA[i].importeIVA = 0;
          documento.basesIVA[i].importeRecargo = 0;
        }

        if (documento.basesIVA[i].porcentajeNoDeducible != 0) {
          documento.basesIVA[i].importeIvaNoDeducible = this.RoundAwayFromZero((documento.basesIVA[i].importeIVA ?? 0) * (documento.basesIVA[i].porcentajeNoDeducible ?? 0) / 100, this.paramDecimalesMoneda);
          documento.basesIVA[i].importeRecargoNoDeducible = this.RoundAwayFromZero((documento.basesIVA[i].importeRecargo ?? 0) * (documento.basesIVA[i].porcentajeNoDeducible ?? 0) / 100, this.paramDecimalesMoneda);
        }
        
      }
      

      documento.totalBases = 0;
      documento.totalIVA = 0;
      documento.totalRecargo = 0;
      documento.totalIvaNoDeducible = 0;

      for (let i = 0; i < documento.basesIVA.length; i++) {
        documento.totalIvaNoDeducible += this.RoundAwayFromZero(documento.basesIVA[i].importeIvaNoDeducible, this.paramDecimalesMoneda);
        documento.totalBases += this.RoundAwayFromZero(documento.basesIVA[i].baseImponible, this.paramDecimalesMoneda);
        if (documento.iva == enumAplicacionIVA.EXENTO) {
          documento.basesIVA[i].importeIVA = 0;
          documento.basesIVA[i].importeRecargo = 0;
        } else {
          documento.totalIVA += this.RoundAwayFromZero(documento.basesIVA[i].importeIVA, this.paramDecimalesMoneda);
          documento.totalRecargo += this.RoundAwayFromZero(documento.basesIVA[i].importeRecargo, this.paramDecimalesMoneda);
        }
        
      }

      documento.sumaAnticipoPre = -1 * sumaAnticiposPre;
      documento.totalDocumento = this.RoundAwayFromZero(documento.totalBases + documento.totalIVA + documento.totalRecargo, this.paramDecimalesMoneda);

      if (sumaImportesCompra > 0) {
        if (sumaImportesCompra > sumaImportesConIva) {
          documento.totalDocumento = this.RoundAwayFromZero(sumaImportesConIva, this.paramDecimalesMoneda);
        }
        else {
          documento.totalDocumento = this.RoundAwayFromZero(documento.totalDocumento + sumaImportesCompra, this.paramDecimalesMoneda);
        }
      }
    } catch (error) {
      console.error('Error al calcular IVA: ', error);
    }
  }

  async calcularRetenciones(documento: DocumentoDTO) {
     let acumuladoRetenciones: number = 0;
     let importeDescuentoGestion: number = 0;
     let acumuladoAjuste: number = 0;
     try {
       documento.retencionesFiscales = [];
       // Recorremos las lineas para calcular las bases de cada una de ellas
       for (let i = 0; i < documento.movimientos.length; i++) {
        if (documento.movimientos[i].tipoLinea != eTipoLineaMovimientos.OBSERVACIONES && documento.movimientos[i].tipoIrpf != null) {
          let retencionDocumento:RetencionFiscalDTO = await this.buscarRetencionEnLista_PorID_TipoImpuesto(documento, documento.movimientos[i].tipoIrpf.id)
          let nuevaRetencionDocumento: boolean = false
          if (!retencionDocumento) {
            nuevaRetencionDocumento = true;
            retencionDocumento = new RetencionFiscalDTO();
            //retencionDocumento.Impuesto = Generales.CNT_IRPF;
            ///retencionDocumento.CodigoImpuesto = movimiento.tipoIrpf.codigo;
            retencionDocumento.actividad = documento.movimientos[i].actividad;
            retencionDocumento.tipoRetencionFiscal = new TipoIrpfGestionDTO()
            retencionDocumento.tipoRetencionFiscal.id = documento.movimientos[i].tipoIrpf.id;
            retencionDocumento.tipoRetencionFiscal.porcentaje = documento.movimientos[i].tipoIrpf.porcentaje
            retencionDocumento.tipoRetencionFiscal.guidRegistro = documento.movimientos[i].tipoIrpf.guidRegistro
            retencionDocumento.tipoRetencionFiscal.codigo = documento.movimientos[i].tipoIrpf.codigo
            retencionDocumento.baseImponible = 0
            
          }
          if (documento.tipoDocumento == enumTipoDocumento.FAC && documento.tipo == enumTipoOperacion.COMPRA && documento.modalidad == eTipoModalidadFacturas.ReciboCompensacion) {
            retencionDocumento.baseImponible += documento.movimientos[i].importeConIva;
          } else {
            retencionDocumento.baseImponible += documento.movimientos[i].importe;
          }
          // if (gestionTiposRetenciones.CargarRegistro_PorId(movimineto.id_TipoRetencion)) {
          //   if (movimiento.tipoRetencion != null) {
          //     movimiento.tipoRetencion = gestionTiposRetenciones.Registro;
          //   }
          //   retencion.Porcentaje = gestionTiposRetenciones.Registro.Porcentaje;
          //   switch (documento.grupo) {
          //     case 'CL':
          //       retencion.CodigoCuentaImpuesto = gestionTiposRetenciones.Registro.CuentaEmitidas;
          //       break;
          //     case 'PR':
          //       retencion.CodigoCuentaImpuesto = gestionTiposRetenciones.Registro.CuentaRecibidas;
          //       break;
          //   }
          //   if (retencion.CodigoCuentaImpuesto && retencion.CodigoCuentaImpuesto != '') {
          //     ProcesarCuentasRetencionActiva("CUENTARETENCION");
          //   }
          // }
          if (nuevaRetencionDocumento) {
           documento.retencionesFiscales.push(retencionDocumento);
         }
        }
        
       }
       // Recorremos las bases para prorratear los descuentos al pie
       if (documento.totalDescuento != 0) {
        for (let i = 0; i < documento.retencionesFiscales.length; i++) {
          importeDescuentoGestion = 0;
           importeDescuentoGestion = this.RoundAwayFromZero((documento.retencionesFiscales[i].baseImponible ?? 0) * documento.totalDescuento / documento.totalBruto, this.paramDecimalesMoneda)
           documento.retencionesFiscales[i].baseImponible -= importeDescuentoGestion
           acumuladoAjuste += importeDescuentoGestion;
          
        }
    
         importeDescuentoGestion = documento.totalDescuento - acumuladoAjuste;
         if (importeDescuentoGestion != 0) {
          for (let i = 0; i < documento.retencionesFiscales.length; i++) {
            if (documento.retencionesFiscales[i].baseImponible != 0) {
              documento.retencionesFiscales[i].baseImponible += importeDescuentoGestion;
              //break;
            }
            
          }
         }
       }
       for (let i = 0; i < documento.retencionesFiscales.length; i++) {
        documento.retencionesFiscales[i].importe = this.RoundAwayFromZero((documento.retencionesFiscales[i].baseImponible ?? 0) * (documento.retencionesFiscales[i].tipoRetencionFiscal.porcentaje ?? 0) / 100, this.paramDecimalesMoneda);
        acumuladoRetenciones += documento.retencionesFiscales[i].importe ?? 0;
        
       }
    
       documento.totalCargosFinal = acumuladoRetenciones;
     } catch (error) {
       console.log('ERROR en la petición calcularRetenciones. ', error);
     }
  }

  calcularTotales(documento: DocumentoDTO) {
      let importeRetencionesObras: number = 0;
    //  if (documento.obra.id /*&& documento.documentoAuxiliarJSON?.datosObra?.retencionAfectaIVA == false*/) {
    //    importeRetencionesObras = gestionMovimientos.ListaRegistros
    //      .filter(m => m.TipoLinea == eTipoLineaMovimientos.RETENCION)
    //      .map(m => m.Importe)
    //      .reduce((sum, current) => sum + current, 0);
    //  }
    
     
     documento.totalAPagar = this.RoundAwayFromZero(documento.totalDocumento - documento.totalCargosFinal - documento.sumaAnticipoPre - importeRetencionesObras, this.paramDecimalesMoneda);
    }

  obtenerTipoOperacionesBasePorTipoArticulo(tipoArticulo: string) {
    let byTipoArticulo: number = 0
    try {
      if (tipoArticulo == eTipoArticulo.AC.toString()) {
        byTipoArticulo = 0;
      } else if (tipoArticulo == eTipoArticulo.PD.toString()) {
        byTipoArticulo = 1;
      } else if (tipoArticulo == eTipoArticulo.SV.toString()) {
        byTipoArticulo = 2;
      } else {
        byTipoArticulo = 1;
      }

    } catch (error) {
      console.error('ERROR en la función obtenerTipoOperacionesBasePorTipoArticulo: ', error);

    }
    return byTipoArticulo;
  }

  buscarBasesLista_PorID_IVA(documento: DocumentoDTO, id_TipoIva: number, regimenFiscal: number, inversion: number, prorrata: number, tipoOperacion: number, porcentajeNoDeducible: number): BaseDocumentoDTO {
    let baseIvaEncontrada: BaseDocumentoDTO = null;
    for (let i = 0; i < documento.basesIVA.length; i++) {
      if (documento.basesIVA[i].tipoIva.id == id_TipoIva && documento.basesIVA[i].regimenFiscal == regimenFiscal && documento.basesIVA[i].inversion == inversion && documento.basesIVA[i].prorrata == prorrata
        && documento.basesIVA[i].tipoOperacion == tipoOperacion && documento.basesIVA[i].porcentajeNoDeducible == porcentajeNoDeducible) {
        baseIvaEncontrada = documento.basesIVA[i];
        return baseIvaEncontrada;
      }
      
    }
    return baseIvaEncontrada
  }

  buscarRetencionEnLista_PorID_TipoImpuesto(documento: DocumentoDTO, id_TipoRetencion: number): RetencionFiscalDTO {
    let retencionFiscalEncontrada: RetencionFiscalDTO = null;
    for (let i = 0; i < documento.retencionesFiscales.length; i++) {
      if (documento.retencionesFiscales[i].tipoRetencionFiscal.id== id_TipoRetencion) {
        retencionFiscalEncontrada = documento.retencionesFiscales[i];
        return retencionFiscalEncontrada;
      }
    }
    return retencionFiscalEncontrada
  }

  insertarBase(posicion: number = 9999999) {
    // try {
    //   _gestionBases.insertarRegistroLista(posicion);
    // } catch (error) {
    //   console.error('ERROR en la función insertarBase: ', error);

    // }
  }

  obtenerTipoArticuloPorMovimiento(movimiento: MovimientoDTO) {
    // let tipoArticulo: string = "";
    // try {
    //   if (movimiento.articuloTipo && movimiento.articuloTipo != '') {
    //     tipoArticulo = movimiento.articuloTipo
    //   } else {
    //     if (_gestorArticulos.CargarRegistro_PorId((int)linea.Id_Articulo)) {
    //       tipoArticulo = _gestorArticulos.Registro.Tipo;
    //     }
    //   }
    // } catch (error) {
    //   console.error('ERROR en la función obtenerTipoArticuloPorMovimiento: ', error);
    // }
    // return tipoArticulo;
  }

  procesarCuentasBaseActiva(proceso: string) {
    // let strAux: string = '';
    // let intAux: number = 0;
    // switch (proceso.toUpperCase()) {
    //   case 'CUENTAIVA':
    //     strAux = baseDocumento.CodigoCuentaIVA;
    //     _funcionesContabilidad.Cuentas.CuentaValidada_AplicacionParametros(ref strAux);
    //     baseDocumento.CodigoCuentaIVA = strAux;
    //     // Si la cuenta está ya creada en base de datos o la tenemos cargada en el registro en espera de guardarse en BD 
    //     if (_gestionCuentas.CargarRegistro_PorCodigo(baseDocumento.CodigoCuentaIVA) || _gestionCuentas.Registro != null
    //       && _gestionCuentas.Registro.Codigo == baseDocumento.CodigoCuentaIVA && _gestionCuentas.Registro.Id > 0) {
    //       baseDocumento.Id_CuentaIVA = _gestionCuentas.Registro.Id;
    //     }
    //     else {
    //       //La creamos
    //       CrearCuentaDesdeMayor(baseDocumento.CodigoCuentaIVA, colBases.usuario.empresaActiva.idEmpresa, ref intAux);
    //       baseDocumento.Id_CuentaIVA = intAux;
    //     }
    //     break;
    //   case "CUENTARECARGO":
    //     strAux = baseDocumento.CodigoCuentaRecargo;
    //     _funcionesContabilidad.Cuentas.CuentaValidada_AplicacionParametros(ref strAux);
    //     baseDocumento.CodigoCuentaRecargo = strAux;
    //     // Si la cuenta está ya creada en base de datos o la tenemos cargada en el registro en espera de guardarse en BD
    //     if (_gestionCuentas.CargarRegistro_PorCodigo(baseDocumento.CodigoCuentaRecargo) || _gestionCuentas.Registro != null
    //       && _gestionCuentas.Registro.Codigo == baseDocumento.CodigoCuentaRecargo && _gestionCuentas.Registro.Id > 0) {
    //       baseDocumento.Id_CuentaRecargo = _gestionCuentas.Registro.Id;
    //     }
    //     else {
    //       //La creamos
    //       CrearCuentaDesdeMayor(baseDocumento.CodigoCuentaRecargo, colBases.usuario.empresaActiva.idEmpresa, ref intAux);
    //       baseDocumento.Id_CuentaRecargo = intAux;
    //     }
    //     break;
    //   case "Id_CUENTAIVA":
    //     if (_gestionCuentas.CargarRegistro_PorID((int)baseDocumento.Id_CuentaIVA)) {
    //       baseDocumento.CodigoCuentaIVA = _gestionCuentas.Registro.Codigo;
    //       strAux = baseDocumento.CodigoCuentaIVA;
    //       _funcionesContabilidad.Cuentas.CuentaValidada_AplicacionParametros(ref strAux);
    //       baseDocumento.CodigoCuentaIVA = strAux;
    //     }
    //     else { baseDocumento.CodigoCuentaIVA = ""; }
    //     break;
    //   case "Id_CUENTARECARGO":
    //     if (_gestionCuentas.CargarRegistro_PorID((int)baseDocumento.Id_CuentaRecargo)) {
    //       strAux = _gestionCuentas.Registro.Codigo;
    //       _funcionesContabilidad.Cuentas.CuentaValidada_AplicacionParametros(ref strAux);
    //       baseDocumento.CodigoCuentaRecargo = strAux;
    //     }
    //     else { baseDocumento.CodigoCuentaRecargo = ""; }
    //     break;
    // }
  }


  rendondear(cantidad: number, numeroDecimales: number) {
    let d: number = cantidad ?? 0;
    //d = Math.round(d, numeroDecimales, MidpointRounding.AwayFromZero )
  }

  RoundAwayFromZero(startValue, digits) {
    var decimalValue: number = 0;
    digits = digits || 0;
    startValue *= Math.pow(10, (digits + 1));
    decimalValue = Math.floor(startValue) - (Math.floor(startValue / 10) * 10);
    startValue = Math.floor(startValue / 10);
    if (decimalValue >= 5) {
      startValue += 1;
    }
    startValue /= Math.pow(10, (digits));
    return startValue;
  }





  calcularPrecioSinIva(precioConIva: number, porcentajeIva: number): number {
    let precioSinIva: number = 0;
    precioSinIva = (porcentajeIva * precioConIva) / 100
    return precioSinIva

  }


  calcularPesoCabecera(listaArticulos: ArticuloDocumentoApp[]): number {
    let sumPeso = 0;
    for (let i = 0; i < listaArticulos.length; i++) {
      sumPeso += listaArticulos[i].articulo?.peso
      
    }
    return sumPeso
  }

  calcularBultosCabecera(listaArticulos: ArticuloDocumentoApp[]): number {
    let sumBultos = 0;
    for (let i = 0; i < listaArticulos.length; i++) {
      sumBultos += listaArticulos[i].articulo?.bultos
    }
    return sumBultos
  }
  //*/
}
